import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

import config from 'config';

export default [
  function LoginDirective() {
    return {
      restrict: 'E',
      controller: 'LoginCtrl',
      controllerAs: 'login',
      bindToController: true,
      template: require('./login.jade')(jadeLocals),
      scope: {
        facebookUser: '=?',
        userRole: '@?',
        hideRegister: '@?',
        successCallback: '&?',
        redirecting: '=?'
      },
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/account/login/login.dir.js